import useWebChat from './useWebChat';

export default useWebChat;
